import { Box, Typography, Button } from '@mui/material/';
import { IoIosHelp, IoIosCloseCircle } from 'react-icons/io';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import Grow from '@mui/material/Grow';
import { CardType } from './styles';

interface ManualProps {
  visible: boolean;
  manualTitle: string;
  itemsManual: Array<{
    itemTitle: string;
    itemBody: string;
  }>;
}

export default function Manual({ visible, itemsManual, manualTitle }: ManualProps): JSX.Element {
  const [visibility, setVisible] = useState<boolean>(visible);

  return (
    <>
      <Button
        onClick={() => {
          setVisible(!visibility);
        }}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '50px',
          minWidth: '20px',
          maxHeight: '50px',
          minHeight: '20px',
          borderRadius: '50%',
          backgroundColor: 'rgba(5,5,5,25%)',
          position: 'fixed',
          right: '3%',
          bottom: '7%',
          zIndex: '1000',
          boxShadow: '2px 1px 2px 1px rgba(0,0,0,0.33)',
        }}
      >
        <IoIosHelp size={50} color='#fff' />
      </Button>

      <Grow in={visibility} style={{ transformOrigin: 'right' }} timeout={visibility ? 500 : 0}>
        <CardType>
          <Button
            onClick={() => setVisible(!visibility)}
            sx={{
              position: 'absolute',
              right: '16px',
              top: '7px',
              width: 'auto',
              minWidth: '5px',
              borderRadius: '50%',
            }}
          >
            <IoIosCloseCircle size={25} color='darkgrey' />
          </Button>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              alignContent: 'center',
              borderRadius: '0px 0px 18px 18px',
              textAlign: 'center',
              backgroundColor: 'white',
              boxShadow: '1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              minWidth: '35%',
              paddingLeft: '12px',
              paddingRight: '12px',
              height: '5%',
              zIndex: '10000',
            }}
          >
            {manualTitle}
          </div>
          <Box sx={{ marginTop: '25px' }}>
            {itemsManual.map((item, indexItem) => (
              <>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1a-content'
                    id={indexItem.toString()}
                  >
                    <Typography sx={{ fontWeight: 'bold' }}>{item.itemTitle}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography align='justify' ml={2} mr={2}>
                      {item.itemBody}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </>
            ))}
          </Box>
        </CardType>
      </Grow>
    </>
  );
}
